import React, { useEffect, useState } from 'react';
import { QuestionRendererProps } from './types';
import { AnalogClock } from '../../visuals/AnalogClock';
import { Clock } from 'lucide-react';
export function ClockRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const targetTimeStr = question.options[question.correctAnswer];
  const [targetHours, targetMinutes, targetSeconds] = targetTimeStr.split(':').map(Number);
  const [hours, setHours] = useState('');
  const [minutes, setMinutes] = useState('');
  const [seconds, setSeconds] = useState('');
  useEffect(() => {
    const isReady = hours !== '' && minutes !== '' && (targetSeconds === undefined || targetSeconds === 0 ? true : seconds !== '');
    onReadyChange(isReady);
  }, [hours, minutes, seconds, targetSeconds, onReadyChange]);
  useEffect(() => {
    if (shouldValidate) {
      const h = hours.padStart(2, '0');
      const m = minutes.padStart(2, '0');
      const s = targetSeconds !== undefined && targetSeconds !== 0 ? seconds.padStart(2, '0') : '00';
      const answerStr = `${h}:${m}:${s}`;
      onAnswer(answerStr);
    }
  }, [shouldValidate, hours, minutes, seconds, targetSeconds, onAnswer]);
  const handleInputChange = (setter: React.Dispatch<React.SetStateAction<string>>, value: string, max: number) => {
    if (value === '' || /^\d+$/.test(value) && parseInt(value) <= max) {
      setter(value);
    }
  };
  const showSeconds = targetSeconds !== undefined && targetSeconds !== 0;
  return <div className="flex flex-col items-center w-full max-w-2xl mx-auto" data-id="element-1419">
      <div className="mb-6 p-4 bg-slate-50 rounded-2xl border border-slate-200 shadow-inner" data-id="element-1420">
        <AnalogClock hours={targetHours} minutes={targetMinutes} seconds={targetSeconds || 0} showSeconds={showSeconds} size={220} data-id="element-1421" />

      </div>

      <div className="w-full bg-white p-5 rounded-xl border-2 border-indigo-100 shadow-sm" data-id="element-1422">
        <h3 className="text-base font-bold text-slate-700 mb-4 flex items-center gap-2" data-id="element-1423">
          <Clock className="w-5 h-5 text-indigo-600" data-id="element-1424" />
          Hoe laat is het?
        </h3>

        <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-1425">
          {/* Hours Input */}
          <div className="flex flex-col items-center" data-id="element-1426">
            <label className="text-xs font-bold text-slate-500 mb-1 uppercase tracking-wide" data-id="element-1427">
              Uur
            </label>
            <input type="text" inputMode="numeric" pattern="[0-9]*" value={hours} onChange={e => handleInputChange(setHours, e.target.value, 23)} placeholder="00" className="w-14 h-14 sm:w-16 sm:h-16 text-center text-xl sm:text-2xl font-bold rounded-xl border-2 border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all placeholder:text-slate-300" maxLength={2} data-id="element-1428" />

          </div>

          <div className="text-2xl font-bold text-slate-300 mt-6" data-id="element-1429">:</div>

          {/* Minutes Input */}
          <div className="flex flex-col items-center" data-id="element-1430">
            <label className="text-xs font-bold text-slate-500 mb-1 uppercase tracking-wide" data-id="element-1431">
              Min
            </label>
            <input type="text" inputMode="numeric" pattern="[0-9]*" value={minutes} onChange={e => handleInputChange(setMinutes, e.target.value, 59)} placeholder="00" className="w-14 h-14 sm:w-16 sm:h-16 text-center text-xl sm:text-2xl font-bold rounded-xl border-2 border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all placeholder:text-slate-300" maxLength={2} data-id="element-1432" />

          </div>

          {/* Seconds Input (Conditional) - FIXED: No more red styling */}
          {showSeconds && <>
              <div className="text-2xl font-bold text-slate-300 mt-6" data-id="element-1433">:</div>
              <div className="flex flex-col items-center" data-id="element-1434">
                <label className="text-xs font-bold text-slate-500 mb-1 uppercase tracking-wide" data-id="element-1435">
                  Sec
                </label>
                <input type="text" inputMode="numeric" pattern="[0-9]*" value={seconds} onChange={e => handleInputChange(setSeconds, e.target.value, 59)} placeholder="00" className="w-14 h-14 sm:w-16 sm:h-16 text-center text-xl sm:text-2xl font-bold rounded-xl border-2 border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all placeholder:text-slate-300" maxLength={2} data-id="element-1436" />

              </div>
            </>}
        </div>

        <p className="text-center text-slate-400 text-sm mt-3" data-id="element-1437">
          Vul de tijd in zoals op de klok (uu:mm{showSeconds ? ':ss' : ''})
        </p>
      </div>
    </div>;
}